export default __webpack_public_path__ + "static/media/tag-yellow.7ef172e7.svg";